import styles from "../FloatingAnnotationToolbar.css";
import classes from "classnames";
import BaseDivider from "../../Divider";

const Divider = ({ className, ...props }) => (
    <BaseDivider className={classes(className, styles.fatDivider)} {...props} />
);

export default Divider;
